__turbopack_context__.v({
  "carouselButton": "e1EWwW_carouselButton",
  "carouselContainer": "e1EWwW_carouselContainer",
  "leftButton": "e1EWwW_leftButton",
  "rightButton": "e1EWwW_rightButton",
  "sliderContainer": "e1EWwW_sliderContainer",
  "sliderWrapper": "e1EWwW_sliderWrapper",
});
